import { FavouriteFilled } from '@ori-ui/icons';
import { colors } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const styleOverrides = {
  iconFilled: {
    color: colors.secondary.light
  },
  iconEmpty: {
    color: colors.oriGrey[200]
  }
};
const defaultProps = {
  icon: /*#__PURE__*/_jsx(FavouriteFilled, {
    fontSize: "inherit"
  }),
  emptyIcon: /*#__PURE__*/_jsx(FavouriteFilled, {
    fontSize: "inherit"
  })
};
export default {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiRating.js.map